<div class="page-content">
    <div class="page-header">
        <h1>
            @if(project && project.code){ 
                {{project.code}} : {{project.label}}
            }
            @else{
                Projet
            }</h1>
        <div class="page-description"><ed-button [colorSchema]="buttonColors.Secondary" (click)="editProject()">Modifier</ed-button>
        </div>
    </div>
    <div class="page-body">
        
        <div class="settings-menu">
            <div *ngFor="let item of menuItems$ | async"
                class="settings-item"
                [routerLink]="item.routerLink"
                routerLinkActive="selected"
                [routerLinkActiveOptions]="item.routerLinkActiveOptions">
                {{ item.display }}
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>

